import React from 'react';
import { useSelector } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import Rotas from '../routes/rotas';
import Navbar from './navbar';

export default function Body() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  return (
    <HashRouter>
      <div className={isLoggedIn ? 'app-shell' : 'auth-shell'}>
        {isLoggedIn ? (
          <>
            <header className="app-header">
              <div className="app-brand">
                <img src="logo.png" alt="Elo Sistemas" className="app-logo" />
              </div>
              <div className="app-navigation">
                <Navbar />
              </div>
            </header>
            <main className="app-content" role="main">
              <Rotas />
            </main>
          </>
        ) : (
          <main className="auth-content">
            <section className="auth-intro">
              <img src="logo.png" alt="Elo Sistemas" className="auth-logo" />
              <span className="auth-eyebrow">Gestão inteligente</span>
              <h1>Seu negócio em movimento, com tudo no lugar.</h1>
              <p>Controle operações, finanças e documentos fiscais em um ambiente único, seguro e eficiente.</p>
              <div className="auth-feature-list">
                <span><i className="pi pi-check-circle" /> Informações centralizadas</span>
                <span><i className="pi pi-check-circle" /> Rotinas mais produtivas</span>
                <span><i className="pi pi-check-circle" /> Acesso protegido</span>
              </div>
            </section>
            <section className="auth-panel">
              <div className="auth-route"><Rotas /></div>
              <span className="auth-version">Elo Sistemas · Versão 1.0.0</span>
            </section>
          </main>
        ) }
      </div>
    </HashRouter>
  );
}
